/**
 * @param token the authentication token
 * @param path the endpoint of the API to call
 * @returns the data that comes back from the API call.
 */

// const baseUrl = "http://localhost:3001" //DEV
const baseUrl = 'https://cwc-backend-heroku.herokuapp.com'; //PRODUCTION

const apiCall = async (token, path, ops, headers) => {
	const options = {
		...ops,
		headers: {
			...headers,
			Authorization: `Bearer ${token}`,
		},
	};

	const url = `${baseUrl}${path}`;
	try {
		const response = await fetch(url, options);
		const data = await response.json();
		return data;
	} catch (error) {
		return console.error(error);
	}
};

export default apiCall;
